export { KrititLandingPage } from "./KrititLandingPage";
